export default __webpack_public_path__ + "static/media/dots-horizontal_blue.f2243569.svg";